export default [
  {
    path: '/contactus',
    name: 'contactus',
    component: () => import('@/views/contactus/ContactUs.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Contact Us',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Contact Us', active: true }]
    }
  }
]